import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { User } from "@/types/auth";

interface UserState {
  user: User | null;
  isAdmin: boolean;
  isAuthenticated: boolean;
  setAuthenticated: (value: boolean) => void;
  setUser: (user: User | null) => void;
  clearUser: () => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      user: null,
      isAdmin: false,
      isAuthenticated: !!localStorage.getItem("auth_token"),

      setAuthenticated: (value) =>
        set({
          isAuthenticated: value,
        }),

      setUser: (user) =>
        set({
          user,
          isAdmin: user?.role?.toLowerCase() === "admin",
          isAuthenticated: !!user,
        }),

      clearUser: () =>
        set({
          user: null,
          isAdmin: false,
          isAuthenticated: false,
        }),
    }),
    {
      name: "user-storage",
      partialize: (state) => ({
        user: state.user,
        isAdmin: state.isAdmin,
        isAuthenticated: state.isAuthenticated,
      }),
      onRehydrateStorage: () => (state) => {
        const hasToken = !!localStorage.getItem("auth_token");
        if (!hasToken) state?.clearUser();
      },
    }
  )
);
